import { SiteLayout } from "./home/SiteLayout";
import { PageHero } from "./home/components/PageHero";
import { Icon } from "./home/components/Icon";
import { SectionHeading } from "./home/components/SectionHeading";
import { RichText, useSiteTranslation } from "./home/i18n";
import "./home/styles/why.css";
import "./behaviour.css";

const VALUE_ICONS = ["eye", "lock", "heart"];
const TAQWA_AYAH = "اتَّقُوا اللَّـهَ مَا اسْتَطَعْتُمْ";
const FURQAN_AYAH = "وَٱلَّذِينَ يَقُولُونَ رَبَّنَا هَبْ لَنَا مِنْ أَزْوَٰجِنَا وَذُرِّيَّـٰتِنَا قُرَّةَ أَعْيُنٍۢ وَٱجْعَلْنَا لِلْمُتَّقِينَ إِمَامًا";

export default function BehaviorComponent() {
  const { t } = useSiteTranslation();
  const values = t("behaviour.values", { returnObjects: true });
  const steps = t("behaviour.steps", { returnObjects: true });

  return (
    <SiteLayout title={t("behaviour.title")}>
      <PageHero eyebrow={t("behaviour.eyebrow")} title={<RichText k="behaviour.heading" />} lead={t("behaviour.lead")} />

      <section className="section behaviour-taqwa">
        <div className="wrap taqwa-grid">
          <figure className="taqwa-card" data-reveal>
            <p className="taqwa-intro">{t("behaviour.taqwaIntro")}</p>
            <blockquote lang="ar" dir="rtl">
              {TAQWA_AYAH}
            </blockquote>
            <figcaption>{t("behaviour.taqwaTranslation")}</figcaption>
          </figure>
          <div className="taqwa-copy" data-reveal>
            <p className="eyebrow">{t("behaviour.taqwaEyebrow")}</p>
            <h2>{t("behaviour.taqwaTitle")}</h2>
            <p>{t("behaviour.taqwaText")}</p>
            <ul>
              <li>
                <Icon name="check" />
                <span>{t("behaviour.keepOnApp")}</span>
              </li>
              <li>
                <Icon name="check" />
                <span>
                  <RichText k="behaviour.report" />
                </span>
              </li>
            </ul>
          </div>
        </div>
      </section>

      <section className="section why">
        <div className="wrap">
          <SectionHeading
            layout="split"
            eyebrow={t("behaviour.valuesEyebrow")}
            title={t("behaviour.valuesTitle")}
            lead={t("behaviour.valuesLead")}
          />
          <div className="pillar-grid">
            {values.map(({ title, text }, index) => (
              <article key={title} className="pillar" data-reveal style={{ "--delay": `${index * 0.08}s` }}>
                <span>
                  <Icon name={VALUE_ICONS[index]} />
                </span>
                <h3>{title}</h3>
                <p>{text}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="section behaviour-steps">
        <div className="wrap">
          <SectionHeading eyebrow={t("behaviour.stepsEyebrow")} title={t("behaviour.stepsTitle")} lead={t("behaviour.stepsLead")} />
          <ol className="step-list">
            {steps.map(({ title, text }, index) => (
              <li key={title} data-reveal style={{ "--delay": `${index * 0.08}s` }}>
                <span>{String(index + 1).padStart(2, "0")}</span>
                <h3>{title}</h3>
                <p>{text}</p>
              </li>
            ))}
          </ol>
        </div>
      </section>

      <section className="behaviour-reflection">
        <div className="wrap reflection-inner" data-reveal>
          <p className="eyebrow">{t("behaviour.reflectionEyebrow")}</p>
          <h2>{t("behaviour.reflectionTitle")}</h2>
          <p className="reflection-desc">{t("behaviour.reflectionText")}</p>
          <blockquote lang="ar" dir="rtl">
            {FURQAN_AYAH}
          </blockquote>
          <p className="reflection-translation">{t("behaviour.reflectionTranslation")}</p>
        </div>
      </section>
    </SiteLayout>
  );
}
